import {
	addDataToArray,
	deleteDataInArray,
	updateDataInArray,
} from 'src/utils/function.utils'
import DictTypes from './dict.types'

const INITIAL_STATE = {
	dictWords: null,
	total: 0,
	currentPage: 1,
	selectedDictWord: null,

	totalWordType: 0,
	currentPageWordType: 1,
	dictWordTypes: null,
	selectedWordType: null,
}

const DictReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case DictTypes.GET_LIST_DICT_WORD:
			return {
				...state,
				dictWords: [...payload.data],
				total: payload.total,
				currentPage: payload.currentPage,
			}
		case DictTypes.SELECT_DICT_WORD:
			return {
				...state,
				selectedDictWord: payload,
			}

		// dict word type
		case DictTypes.GET_ALL_DICT_WORD_TYPE:
			return {
				...state,
				dictWordTypes: [...payload.data],
				totalWordType: payload.total,
				currentPageWordType: payload.currentPage,
			}

		case DictTypes.CREATE_DICT_WORD_TYPE: {
			const data = addDataToArray(state.dictWordTypes, payload)
			return {
				...state,
				dictWordTypes: data,
				totalWordType: state.totalWordType + 1,
			}
		}
		case DictTypes.SELECT_DICT_WORD_TYPE: {
			return {
				...state,
				selectedWordType: payload,
			}
		}
		case DictTypes.UPDATE_DICT_WORD_TYPE: {
			const data = updateDataInArray(state.dictWordTypes, payload)
			return {
				...state,
				dictWordTypes: data,
			}
		}
		case DictTypes.DELETE_DICT_WORD_TYPE: {
			const data = deleteDataInArray(state.dictWordTypes, payload)
			return {
				...state,
				dictWordTypes: data,
				totalWordType: Math.max(state.totalWordType - 1, 0),
			}
		}

		// dict word
		case DictTypes.CREATE_DICT_WORD: {
			const data = addDataToArray(state.dictWords, payload)
			return {
				...state,
				dictWords: data,
				total: state.total + 1,
			}
		}

		case DictTypes.UPDATE_DICT_WORD: {
			const data = updateDataInArray(state.dictWords, payload)
			return {
				...state,
				dictWords: data,
				total: state.total + 1,
			}
		}

		case DictTypes.DELETE_DICT_WORD: {
			const data = deleteDataInArray(state.dictWords, payload)
			return {
				...state,
				dictWords: data,
				total: Math.max(state.total - 1, 0),
			}
		}

		default:
			return state
	}
}

export default DictReducer
